import {
	type Activity,
	apiAppBusinessActivityUpsertactivity,
	apiAppBusinessActivityDeleteactivity
} from '#lib/types/generated/index.js';
import { optimisticDelete, optimisticSave } from '#lib/stores/optimistic.js';
import { get, writable } from 'svelte/store';

export const activityStore = writable<Activity[]>([]);

export function findActivity(id: string): Activity | undefined {
	return get(activityStore).find((activity) => activity.id === id);
}

export function saveActivity(activity: Activity): Promise<Activity> {
	return optimisticSave(activityStore, activity, () =>
		apiAppBusinessActivityUpsertactivity(activity.id, activity)
	);
}

export async function deleteActivity(activity: Activity): Promise<void> {
	await optimisticDelete(activityStore, activity, () =>
		apiAppBusinessActivityDeleteactivity(activity.id)
	);
}
